"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdown = void 0;
exports.dropdown = {
    path: "M3.5 3L0.468911 -9.41288e-08L6.53109 4.35844e-07L3.5 3Z",
    originalWidth: 6,
    originalHeight: 6,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
